import React from 'react';
import './Features.css';

const Features: React.FC = () => {
  const features = [
    {
      icon: '💰',
      title: 'Affordable & Transparent',
      description: 'No expensive memberships or hidden fees. Pay only for the services you need, or skip the bill entirely by learning to do it yourself.'
    },
    {
      icon: '⚡',
      title: 'Fast Roadside Help',
      description: 'Connect with nearby community members for faster help than traditional roadside assistance services when you need it most.'
    },
    {
      icon: '📚',
      title: 'Step-by-Step Tutorials',
      description: 'Follow clear, beginner-friendly guides for oil changes, tire care, fluid checks, and other common maintenance tasks.'
    },
    {
      icon: '👨‍🏫',
      title: 'Learn from Locals',
      description: 'Get taught hands-on by experienced community members who know your make and model — not just a generic YouTube video.'
    },
    {
      icon: '🔒',
      title: 'Verified & Safe',
      description: 'All helpers and instructors are identity-verified. Safety checklists and best practices are built into every tutorial.'
    },
    {
      icon: '👥',
      title: 'Community-Driven',
      description: 'Help your neighbors when they need it, teach someone a new skill, or learn from verified community members in your area.'
    },
    {
      icon: '⭐',
      title: 'Bidirectional Rating System',
      description: 'Rate your experience whether you received help or learned a new skill — building trust across the whole community.'
    },
    {
      icon: '📱',
      title: 'Real-time Communication',
      description: 'Live GPS tracking for roadside help, in-app messaging, and direct Q&A with mentors during DIY sessions.'
    }
  ];

  return (
    <section id="features" className="features">
      <div className="features-container">
        <div className="features-header">
          <h2 className="features-title">Why Choose GetStrandX?</h2>
          <p className="features-subtitle">
            Get help when you're stranded, or learn the skills to handle it yourself next time
          </p>
          <div className="features-prelaunch-notice">
            <p className="features-prelaunch-text">🚀 <strong>Coming Soon:</strong> Roadside assistance and DIY car care in one community platform</p>
          </div>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
